<template>
  <fieldset>
    <legend>
      <span class="pull-left">{{ $t('form.sickness.legend') }}</span>
      <!-- <a class="fa fa-question-circle" @click="displayModal($event, 0)" /> -->
      <a
        class="pull-right"
        ref="collapseLink"
        data-toggle="collapse"
        href="#collapse_sickness"
        role="button"
        aria-expanded="true"
        aria-controls="collapse_sickness"
      >
        <span class="fa fa-angle-up"></span>
        <span class="fa fa-angle-down"></span>
      </a>
    </legend>

    <modal v-show="modals[0]" @close="$set(modals, 0, false)">
      <h2 slot="modal-header">{{ $t('form.sickness.legend') }}</h2>
      <div slot="modal-body"></div>
    </modal>

    <div class="collapse show" id="collapse_sickness" ref="collapseElement">
      <div class="form-group">
        <div>
          <label for="sickness_now">
            <input type="checkbox" id="sickness_now" v-model="sickness.reportNow" />
            {{ $t('form.sickness.report_now.label') }}
          </label>
        </div>
      </div>

      <div class="form-group">
        <div>
          <label for="sickness_three_days">
            <input type="checkbox" id="sickness_three_days" v-model="sickness.reportThreeDays" />
            {{ $t('form.sickness.report_three_days.label') }}
          </label>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  data() {
    return {
      sickness: {
        reportNow: false,
        reportThreeDays: false
      }
    };
  },
  watch: {
    sickness: {
      handler() {
        this.$store.commit("updateSickness", this.sickness);
      },
      deep: true
    }
  }
};
</script>